import { render, staticRenderFns } from "./CrmLeadDetailApi.vue?vue&type=template&id=1b733fb0&lang=pug&"
import script from "./CrmLeadDetailApi.vue?vue&type=script&lang=js&"
export * from "./CrmLeadDetailApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports